function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router-dom';
import { FullPageModal, FullPageModalHeaderStart, FunctionalLoader, Typography } from 'seagull';
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useContacts } from "../../hooks/reactQuery/queries/useContacts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { useServiceTemplateApi } from "../../hooks/useServiceTemplateApi";
import { wait } from "../../infra/utils";
import StripeElementsProvider from "../../providers/StripeElementsProvider";
import { selectors } from "../../store/state-selectors";
import FeatureFlagsRelationshipContext from "../FeatureFlagsRelationshipContext";
import styles from "./FullPageInvoice.module.scss";
import FullPageInvoiceWithData from "./FullPageInvoiceWithData";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function FullPageInvoice(props) {
  const {
    invoiceId,
    relationshipId,
    dismissModal,
    onRefresh
  } = props;
  const {
    api
  } = useStoreActions();
  const {
    contacts,
    refresh: fetchContacts,
    isLoading: contactsLoading
  } = useContacts({
    refreshOnMount: true
  });
  const isVendor = useStore(selectors.user.isVendor);
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const showInvoiceQboSection = useStore(selectors.integration.showInvoiceQboSection);
  const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
  const showInvoiceXeroSection = useStore(selectors.integration.showInvoiceXeroSection);
  const {
    HEADER_LAYOUT_UPDATES
  } = useFeatureFlags();
  const history = useHistory();
  const serviceTemplateApi = useServiceTemplateApi();
  const _fetch = async isInitialLoading => {
    if (!invoiceId || !relationshipId) throw new Error('missing data');
    const [invoice, relationship, serviceTemplates] = await Promise.all([api.invoice.getByID(invoiceId, !isVendor), api.relationship.get(relationshipId), showInvoiceQboSection || showInvoiceXeroSection ? serviceTemplateApi.getForInvoice(invoiceId) : Promise.resolve([]), isInitialLoading ? Promise.resolve() : fetchContacts()]);
    return {
      relationship,
      invoice,
      serviceTemplates
    };
  };
  return /*#__PURE__*/_jsx(FullPageModal, {
    showFooter: !HEADER_LAYOUT_UPDATES,
    newUI: HEADER_LAYOUT_UPDATES,
    contentSkin: "white",
    "data-testid": "fpi",
    onClose: () => dismissModal(),
    children: /*#__PURE__*/_jsx(StripeElementsProvider, {
      children: /*#__PURE__*/_jsx(RestfulWrapper, {
        initialArgs: {
          isInitialLoading: true
        },
        fetch: _ref => {
          let {
            isInitialLoading
          } = _ref;
          return _fetch(isInitialLoading);
        },
        renderChild: _ref2 => {
          let {
            data,
            refresh: _refresh
          } = _ref2;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FunctionalLoader, {
              show: contactsLoading
            }), /*#__PURE__*/_jsx(FeatureFlagsRelationshipContext, {
              vendorId: data.relationship.vendor.id,
              children: /*#__PURE__*/_jsx(FullPageInvoiceWithData, _objectSpread(_objectSpread({}, data), {}, {
                contacts: contacts,
                showQboIntegration: showQboIntegration,
                showInvoiceQboSection: showInvoiceQboSection,
                showXeroIntegration: showXeroIntegration,
                showInvoiceXeroSection: showInvoiceXeroSection,
                isVendor: isVendor,
                onRefresh: onRefresh,
                refresh: () => _refresh({
                  args: {
                    isInitialLoading: false
                  }
                }),
                onRedirectToPaymentMethods: async () => {
                  dismissModal();
                  await wait(0);
                  history.push(routes.paymentMethods(data.relationship.id));
                }
              }))
            })]
          });
        },
        renderError: () => /*#__PURE__*/_jsxs("div", {
          className: styles.error,
          "data-testid": "fpi-error",
          children: [/*#__PURE__*/_jsx(FullPageModalHeaderStart, {
            children: "Error"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            children: "This invoice could not be loaded. Please try again later."
          })]
        })
      })
    })
  });
}